import React, { createElement, useRef, useEffect } from 'react';
import { trescatinfoComponents } from 'components/3catinfo';
import __isEmpty from 'lodash/isEmpty';
import __isUndefined from 'lodash/isUndefined';
import clsx from 'clsx';
import styles from '../contingutEstatic.module.scss';

const Embed = (props) => {
    const { text, tipus, component } = props;
    const htmlRoot = useRef();

    const stylesEmbed = clsx({
        [styles.embed]: true,
        [styles[tipus]]: !!tipus,
        [props.class]: !!props.class
    });

    useEffect(() => {
        const range = document.createRange();
        const documentFragment = range.createContextualFragment(text);
        if (!__isUndefined(htmlRoot.current)) htmlRoot.current.append(documentFragment);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!__isEmpty(component)) {
        const { name, props: propsComponent } = component;
        if (__isEmpty(trescatinfoComponents[name])) return <></>;
        return (
            <div className={stylesEmbed} data-testid={`contingut-parsejat-embed-${tipus}-${name}`}>
                {createElement(trescatinfoComponents[name].dynamicComponent, {
                    ...propsComponent
                })}
            </div>
        );
    }

    return <div className={stylesEmbed} ref={htmlRoot} />;
};

export default Embed;
